/* sportsAssets — single resolver for team crests and player headshots (README §7).
   Order: provider URL on the payload → configured asset map (kept out of components;
   can be fed by env/JSON later) → the authoritative ESPN name→logo map → null.
   Isolating the ESPN hot-link here contains the licensing risk (bug #9) and gives
   one place to swap in a licensed asset source. Components own the visual fallback
   (team monogram / player initials) when this returns null. */
import { resolveTeamLogo as espnTeamLogo } from "@/constants/teamLogos";

const norm = (s) => String(s || "").trim().toLowerCase();

// Configured maps — empty by default (provider URLs + ESPN cover current needs).
// Populate from a licensed source later without touching components.
const TEAM_ASSET_MAP = {};   // normalized name/abbr -> url
const PLAYER_ASSET_MAP = {}; // normalized player name -> url

export function resolveTeamLogo({ league, name, abbr, providerLogoUrl } = {}) {
  if (providerLogoUrl) return providerLogoUrl;
  const mapped = TEAM_ASSET_MAP[norm(name)] || (abbr ? TEAM_ASSET_MAP[norm(abbr)] : null);
  if (mapped) return mapped;
  const espn = espnTeamLogo(name, league, "");
  return espn || null;
}

export function resolvePlayerHeadshot({ player, providerImageUrl } = {}) {
  if (providerImageUrl) return providerImageUrl;
  return PLAYER_ASSET_MAP[norm(player)] || null;
}
